/**
 * AJAX live search for the search drawer.
 * Fetches from Shopify predictive search API and injects results.
 */
(function () {
  var DEBOUNCE_MS = 300;
  var RESULTS_CONTAINER_ID = 'search-drawer-ajax-results';
  var INPUT_SELECTOR = '.search-drawer__input';
  var DRAWER_SELECTOR = 'search-drawer';

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function getInput() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector(INPUT_SELECTOR) : null;
  }

  function getResultsContainer() {
    return document.getElementById(RESULTS_CONTAINER_ID);
  }

  function getSuggestionsEl() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('[data-search-drawer-suggestions]') : null;
  }

  function showLoading(container) {
    if (!container) return;
    container.setAttribute('aria-busy', 'true');
    container.innerHTML = '';
  }

  function showResults(container, html) {
    if (!container) return;
    container.removeAttribute('aria-busy');
    container.classList.remove('search-drawer-ajax--loading');
    container.innerHTML = html || '';
  }

  function showNoResults(container) {
    if (!container) return;
    container.removeAttribute('aria-busy');
    container.classList.remove('search-drawer-ajax--loading');
    container.innerHTML = '';
    setResultsVisible(false);
  }

  function showError(container) {
    if (!container) return;
    container.removeAttribute('aria-busy');
    container.classList.remove('search-drawer-ajax--loading');
    container.innerHTML =
      '<div class="search-drawer-ajax__empty" role="alert">Something went wrong. Try again.</div>';
  }

  function setResultsVisible(visible) {
    var container = getResultsContainer();
    var suggestions = getSuggestionsEl();
    if (container) {
      container.style.display = visible ? 'block' : 'none';
    }
    if (suggestions) {
      suggestions.style.display = visible ? 'none' : 'block';
    }
  }

  function performSearch(query, controller) {
    var container = getResultsContainer();
    if (!container || typeof routes === 'undefined' || !routes.predictive_search_url) {
      return;
    }

    var tagExclusionSuffix = ' NOT tag:nosearch NOT tag:no_rebuy_upsell NOT tag:free-gift NOT tag:exclude';
    var url =
      routes.predictive_search_url +
      '?q=' +
      encodeURIComponent(query + tagExclusionSuffix) +
      '&section_id=predictive-search';

    showLoading(container);
    setResultsVisible(true);

    fetch(url, { signal: controller ? controller.signal : undefined })
      .then(function (response) {
        if (!response.ok) throw new Error('Search failed');
        return response.text();
      })
      .then(function (text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');
        var section = doc.querySelector('#shopify-section-predictive-search');
        // Remove the predictive-search loading spinner — it has no explicit size
        // and renders at ~300px when injected outside its predictive-search parent
        if (section) {
          section.querySelectorAll('.predictive-search__loading-state').forEach(function (el) {
            el.remove();
          });
        }
        var html = section ? section.innerHTML : '';

        if (!html || html.trim().length === 0) {
          showNoResults(container);
          return;
        }

        showResults(container, html);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showError(container);
      });
  }

  function onInput() {
    var input = getInput();
    var container = getResultsContainer();
    var query = input ? input.value.trim() : '';

    if (!query) {
      setResultsVisible(false);
      if (container) {
        container.innerHTML = '';
        container.classList.remove('search-drawer-ajax--loading');
      }
      return;
    }

    if (!window.searchDrawerAjaxController) {
      window.searchDrawerAjaxController = new AbortController();
    }
    window.searchDrawerAjaxController.abort();
    window.searchDrawerAjaxController = new AbortController();

    performSearch(query, window.searchDrawerAjaxController);
  }

  function init() {
    var drawer = getDrawer();
    var input = getInput();
    if (!drawer || !input) return;

    var debouncedSearch =
      typeof debounce === 'function'
        ? debounce(onInput, DEBOUNCE_MS)
        : function () {
            setTimeout(onInput, DEBOUNCE_MS);
          };

    input.addEventListener('input', debouncedSearch);
    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q) {
        setResultsVisible(true);
        if (getResultsContainer() && getResultsContainer().innerHTML.trim() === '') {
          onInput();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
